import React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import WipeDeviceData from "../modals/WipeDeviceData";
import DeleteDevice from "../modals/DeleteDevice";
import FindTheDevice from "../modals/FindTheDevice";
import ManualScreenshotModal from "../modals/ManualScreenshotModal";
import { pushScreenshotApi } from "../../AxiosRtk/Screenshot";
import { useDispatch, useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";
import useSubscription from "../../../customHooks/subscriptionProvider";
import { setShowInfo } from "../../AxiosRtk/successMessage";

const DashboardIconFun = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showFindDeviceModal, setShowFindDeviceModal] = useState(false);
  const [showManualScreenshotModal, setShowManualScreenshotModal] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { selectedDeviceData, kidList } = useSelector(
    ({ dashboard }) => dashboard
  );
  const dispatch = useDispatch();

  const { getLangTranslation } = useLangTranslation();
  const { checkSubsciption } = useSubscription();
  const isKidListEmpty = kidList?.length === 0 ? true : false;

  const openDeleteModal = () => {
    if (kidList?.length === 0 || !selectedDeviceData || !checkSubsciption()) {
      return;
    }
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const openModal = () => {
    if (kidList?.length === 0 || !selectedDeviceData || !checkSubsciption()) {
      return;
    }
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openFindDeviceModal = () => {
    if (kidList?.length === 0 || !selectedDeviceData || !checkSubsciption()) {
      return;
    }
    setShowFindDeviceModal(true);
  };

  const closeFindDeviceModal = () => {
    setShowFindDeviceModal(false);
  };

  const openManualScreenshotModal = async () => {
    // Always allow clicking, but check conditions inside
    try {
      // Check if kidList is empty or subscription invalid
      if (kidList?.length === 0 || !checkSubsciption()) {
        dispatch(
          setShowInfo({
            showInfo: true,
            title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
            defaultTitle: "Please setup your child's device first",
          })
        );
        return;
      }
  
      // Check if device is selected
      if (!selectedDeviceData) {
        dispatch(
          setShowInfo({
            showInfo: true,
            title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
            defaultTitle: "Please select a device first",
          })
        );
        return;
      }
  
      // Find the kid associated with the selected device
      const selectedKid = kidList.find(kid => 
        kid.KidsDevices.some(device => device.KidsDeviceId === selectedDeviceData?.ID)
      );
  
      // If no matching kid found for the selected device
      if (!selectedKid) {
        dispatch(
          setShowInfo({
            showInfo: true,
            title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
            defaultTitle: "No device linked to this child",
          })
        );
        return;
      }
  
      // Prepare payload for screenshot API
      const payload = {
        case: 1,
        deviceId: selectedDeviceData?.ID,
        kidId: selectedKid?.ID,
      };
  
      // Call the API
      const { data } = await pushScreenshotApi(payload);
  
      // If API call successful, show the manual screenshot modal
      if (data) {
        setShowManualScreenshotModal(true);
        setErrorMessage(""); // Clear any previous errors
      }
    } catch (error) {
      // Handle API errors
      setErrorMessage(
        error?.response?.data?.message || 
        "Failed to initiate manual screenshot"
      );
      setShowManualScreenshotModal(true); // Still show modal to display error
    }
  };


  const closeManualScreenshotModal = () => {
    setShowManualScreenshotModal(false);
  };

  function handleRouteMove(route = null) {
    if (kidList?.length === 0 || !checkSubsciption()) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please setup your child's device first",
        })
      );
      return;
    }
  
    if (!selectedDeviceData) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "Please select a device first",
        })
      );
      return;
    }
  
    const selectedKid = kidList.find((kid) =>
      kid.KidsDevices.some(
        (device) => device.KidsDeviceId === selectedDeviceData?.ID
      )
    );
  
    if (!selectedKid) {
      dispatch(
        setShowInfo({
          showInfo: true,
          title: "PARENT_DASHBOARD_DEVICE_SETUP_NOT_FINISHED",
          defaultTitle: "No device linked to this child",
        })
      );
      return;
    }
  
    // All checks passed, navigate to route
    switch (route) {
      case "LOCK_CHILD_DEVICE":
        history.push("/lock-child-device");
        break;
      case "CHILD_CONTACTS":
        history.push("/child-contacts");
        break;
      case "DEVICE_SETTINGS":
        history.push("/device-settings");
        break;
      default:
        history.push("/dashboard");
    }
  }
  

  return (
    <>
      <div className="d-flex flew-wrap justify-content-between">
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => openManualScreenshotModal()}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-yellow"
              } me-2`}
          >
            <i className={`icon-camera ${isKidListEmpty ? "text-gray" : ""}`} />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "CHILD_DETAIL_SCREENSHOT",
                "Manual screenshot"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "CHILD_DETAIL_SCREENSHOT",
                "Manual screenshot"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => handleRouteMove("LOCK_CHILD_DEVICE")}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-red"
              } me-2`}
          >
            <i className={`icon-lock ${isKidListEmpty ? "text-gray" : ""}`} />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "CHILD_DETAIL_DEVICE_LOCK",
                "Lock child device"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "CHILD_DETAIL_DEVICE_LOCK",
                "Lock child device"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => handleRouteMove("CHILD_CONTACTS")}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-blue"
              } me-2`}
          >
            <i
              className={`icon-contact-file ${isKidListEmpty ? "text-gray" : ""
                }`}
            />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "DEVICE_DETAIL_CHILD_CONTACTS",
                "Child's contacts"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "DEVICE_DETAIL_CHILD_CONTACTS",
                "Child's contacts"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => handleRouteMove("DEVICE_SETTINGS")}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-green"
              } me-2`}
          >
            <i
              className={`icon-setting ${isKidListEmpty ? "text-gray" : ""}`}
            />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "DASHBOARD_DEVICE_SETTINGS",
                "Device Settings"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "DASHBOARD_DEVICE_SETTINGS",
                "Device Settings"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => openModal()}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-red"
              } me-2`}
          >
            <i className={`icon-folder ${isKidListEmpty ? "text-gray" : ""}`} />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "CHILD_NAV_WIPE_DEVICE_DATA",
                "Wipe device data"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "CHILD_NAV_WIPE_DEVICE_DATA",
                "Wipe device data"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={() => openFindDeviceModal()}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-purple"
              } me-2`}
          >
            <i
              className={`icon-location ${isKidListEmpty ? "text-gray" : ""}`}
            />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "DEVICE_DETAIL_FIND_DEVICE",
                "Find the device"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "DEVICE_DETAIL_FIND_DEVICE",
                "Find the device"
              )}
            </h6>
          )}
        </div>
        <div
          className="d-flex align-items-center list-item c-pointer"
          onClick={openDeleteModal}
        >
          <span
            className={`icon-wrap ${isKidListEmpty ? "icon-gray" : "icon-red"
              } me-2`}
          >
            <i className={`icon-trash ${isKidListEmpty ? "text-gray" : ""}`} />
          </span>
          {isKidListEmpty ? (
            <p className="my-0 text-gray">
              {getLangTranslation(
                "DEVICE_DETAIL_BUTTON_DELTE_DEVICE",
                "Delete device"
              )}
            </p>
          ) : (
            <h6 className="my-0 text-dark">
              {getLangTranslation(
                "DEVICE_DETAIL_BUTTON_DELTE_DEVICE",
                "Delete device"
              )}
            </h6>
          )}
        </div>
      </div>

      <WipeDeviceData
        showModal={showModal}
        closeModal={closeModal}
        getLangTranslation={getLangTranslation}
      />
      <DeleteDevice
        showModal={showDeleteModal}
        closeModal={closeDeleteModal}
        getLangTranslation={getLangTranslation}
      />
      <FindTheDevice
        showModal={showFindDeviceModal}
        closeModal={closeFindDeviceModal}
        getLangTranslation={getLangTranslation}
      />
      <ManualScreenshotModal
        showModal={showManualScreenshotModal}
        closeModal={closeManualScreenshotModal}
        errorMessage={errorMessage}
        getLangTranslation={getLangTranslation}
      />
    </>
  );
};

export default DashboardIconFun;
